__turbopack_export_value__({
  "body-logo-18": "FullTestimonialPopup-module-scss-module__raiaDG__body-logo-18",
  "body-text-12": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-12",
  "body-text-14": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-14",
  "body-text-16": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-16",
  "body-text-18": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-18",
  "body-text-20": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-20",
  "body-text-24": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-24",
  "body-text-24-2": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-24-2",
  "body-text-heading-2": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-heading-2",
  "body-text-heading-3": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-heading-3",
  "body-text-medium-14": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-medium-14",
  "body-text-medium-16": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-medium-16",
  "body-text-medium-18": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-medium-18",
  "body-text-medium2-18": "FullTestimonialPopup-module-scss-module__raiaDG__body-text-medium2-18",
  "body-text2-14": "FullTestimonialPopup-module-scss-module__raiaDG__body-text2-14",
  "body-text2-16": "FullTestimonialPopup-module-scss-module__raiaDG__body-text2-16",
  "button-primary-text": "FullTestimonialPopup-module-scss-module__raiaDG__button-primary-text",
  "button-text": "FullTestimonialPopup-module-scss-module__raiaDG__button-text",
  "button2-text": "FullTestimonialPopup-module-scss-module__raiaDG__button2-text",
  "card-shadow": "FullTestimonialPopup-module-scss-module__raiaDG__card-shadow",
  "effect-menu": "FullTestimonialPopup-module-scss-module__raiaDG__effect-menu",
  "fullTestimonial": "FullTestimonialPopup-module-scss-module__raiaDG__fullTestimonial",
  "fullTestimonial__item": "FullTestimonialPopup-module-scss-module__raiaDG__fullTestimonial__item",
  "header-1": "FullTestimonialPopup-module-scss-module__raiaDG__header-1",
  "main-container": "FullTestimonialPopup-module-scss-module__raiaDG__main-container",
  "main-footer-container": "FullTestimonialPopup-module-scss-module__raiaDG__main-footer-container",
  "main-header-container": "FullTestimonialPopup-module-scss-module__raiaDG__main-header-container",
  "txt-12-bold": "FullTestimonialPopup-module-scss-module__raiaDG__txt-12-bold",
  "txt-14-bold": "FullTestimonialPopup-module-scss-module__raiaDG__txt-14-bold",
  "txt-14-bold-caps": "FullTestimonialPopup-module-scss-module__raiaDG__txt-14-bold-caps",
  "txt-14-med": "FullTestimonialPopup-module-scss-module__raiaDG__txt-14-med",
  "txt-16-bold": "FullTestimonialPopup-module-scss-module__raiaDG__txt-16-bold",
  "txt-16-med": "FullTestimonialPopup-module-scss-module__raiaDG__txt-16-med",
  "txt-18-bold": "FullTestimonialPopup-module-scss-module__raiaDG__txt-18-bold",
  "txt-18-medium": "FullTestimonialPopup-module-scss-module__raiaDG__txt-18-medium",
  "txt-18-medium-24": "FullTestimonialPopup-module-scss-module__raiaDG__txt-18-medium-24",
  "txt-24-semi": "FullTestimonialPopup-module-scss-module__raiaDG__txt-24-semi",
});
